import { destroy } from "redux-form";
import { all, put, select, takeLatest } from "redux-saga/effects";
import { confirmDialogPropsSelector, uiActions } from "../store/ui.store";
import { ConfirmDialogProps } from "../types/types";

/**
 * システムがメッセージバーを表示する
 * @param action
 */
function* onSystemShowMessageBar(
  action: ReturnType<typeof uiActions.SYSTEM_SHOW_MESSAGE_BAR>
) {
  yield put(
    uiActions.REDUCER_SHOW_MESSAGE_BAR({ message: action.payload.message })
  );
}

/**
 * システムがメッセージバーを非表示にする
 */
function* onSystemHideMessageBar() {
  yield put(uiActions.REDUCER_HIDE_MESSAGE_BAR());
}

/**
 * システムがダイアログを開く
 * @param action
 */
function* onSystemOpenDialog(
  action: ReturnType<typeof uiActions.SYSTEM_OPEN_DIALOG>
) {
  yield put(
    uiActions.REDUCER_SET_DIALOG_PROPS({
      dialogProps: {
        type: action.payload.type,
        title: action.payload.title,
        isOpen: true,
        isModal: action.payload.isModal
      }
    })
  );
}

/**
 * システムがダイアログを閉じる
 * @param action
 */
function* onSystemCloseDialog(
  action: ReturnType<typeof uiActions.SYSTEM_CLOSE_DIALOG>
) {
  if (action.payload.formId) {
    yield put(destroy(action.payload.formId));
  }

  yield put(
    uiActions.REDUCER_SET_DIALOG_PROPS({
      dialogProps: {
        isOpen: false
      }
    })
  );
}

/**
 * システムが確認ダイアログを開く
 * @param action
 */
function* onSystemOpenConfirmDialog(
  action: ReturnType<typeof uiActions.SYSTEM_OPEN_CONFIRM_DIALOG>
) {
  yield put(
    uiActions.REDUCER_SET_CONFIRM_DIALOG_PROPS({
      title: action.payload.title,
      subText: action.payload.subText,
      isOpen: true,
      primaryAction: action.payload.primaryAction,
      secondaryAction: action.payload.secondaryAction
    })
  );
}

/**
 * システムが確認ダイアログを閉じる
 */
function* onSystemCloseConfirmDialog() {
  yield put(
    uiActions.REDUCER_SET_CONFIRM_DIALOG_PROPS({
      title: undefined,
      isOpen: false,
      primaryAction: undefined,
      secondaryAction: undefined
    })
  );
}

/**
 * ユーザーが確認ダイアログのメインボタンをクリックした
 */
function* onUserClickedConfirmPrimaryButton() {
  const props: ConfirmDialogProps = yield select(confirmDialogPropsSelector);
  const { primaryAction } = props;

  if (primaryAction) {
    yield put(primaryAction);
  }

  yield put(uiActions.SYSTEM_CLOSE_CONFIRM_DIALOG());
}

/**
 * ユーザーが確認ダイアログのサブボタンをクリックした
 */
function* onUserClickedConfirmSecondaryButton() {
  const props: ConfirmDialogProps = yield select(confirmDialogPropsSelector);
  const { secondaryAction } = props;

  if (secondaryAction) {
    yield put(secondaryAction);
  }

  yield put(uiActions.SYSTEM_CLOSE_CONFIRM_DIALOG());
}

/**
 * ユーザーがダイアログクローズボタンをクリックした
 */
function* onUserClickedCloseDialogButton() {
  yield put(uiActions.SYSTEM_CLOSE_DIALOG({}));
}

/**
 * UI Saga
 */
export function* uiSaga() {
  yield all([
    yield takeLatest(uiActions.SYSTEM_SHOW_MESSAGE_BAR, onSystemShowMessageBar),
    yield takeLatest(uiActions.SYSTEM_HIDE_MESSAGE_BAR, onSystemHideMessageBar),
    yield takeLatest(uiActions.SYSTEM_OPEN_DIALOG, onSystemOpenDialog),
    yield takeLatest(uiActions.SYSTEM_CLOSE_DIALOG, onSystemCloseDialog),
    yield takeLatest(
      uiActions.SYSTEM_OPEN_CONFIRM_DIALOG,
      onSystemOpenConfirmDialog
    ),
    yield takeLatest(
      uiActions.SYSTEM_CLOSE_CONFIRM_DIALOG,
      onSystemCloseConfirmDialog
    ),
    yield takeLatest(
      uiActions.USER_CLICKED_CONFIRM_PRIMARY_BUTTON,
      onUserClickedConfirmPrimaryButton
    ),
    yield takeLatest(
      uiActions.USER_CLICKED_CONFIRM_SECONDARY_BUTTON,
      onUserClickedConfirmSecondaryButton
    ),
    yield takeLatest(
      uiActions.USER_CLICKED_CLOSE_DIALOG_BUTTON,
      onUserClickedCloseDialogButton
    )
  ]);
}
